<template>
  <v-dialog v-model="value" max-width="1000" scrollable persistent>
    <v-card outlined>
      <v-overlay absolute v-if="isLoading" opacity="1" color="white">
        <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
      </v-overlay>
      <v-card-title class="d-flex justify-space-between align-center primary white--text">
        <div  v-if="typeChartDialog == 'product_type_proportion'">
          {{ $t('product.product_type_proportion') }}
        </div>
        <div v-else>
          {{ $t('project.proportion_of') }}<span>{{ dataModalPrepare.name || '-' }}</span>
        </div>
        <v-btn color="white" icon @click="dismiss();">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="!isLoading && typeChartDialog == 'product_type_proportion' && dataModalPrepare">
        <div class="box-chart-type bd-bottom">
          <v-card elevation="0" class="wrapper">
            <div class="col-left">
              <div class="header">
                <div class="sub-title mb-2">{{ $t('product.product_type_of_market', {name: marketName}) }}</div>
                <div class="txt-title">{{ $t('product.product_type_of_market_ratio') }}</div>
              </div>
              <div class="body">
                <div id="custom-pie-legend-dialog" class="product-category"></div>
              </div>
            </div>
            <div class="col-right">
              <div class="pie-chart-box container-pie-tooltip position-relative">
                <canvas id="pie-chart-dialog" v-show="dataModalPrepare && dataModalPrepare"></canvas>
                <div v-show="dataModalPrepare && !dataModalPrepare" class="no-data">
                  {{ $t('product.no_product') }}
                </div>
              </div>
            </div>
          </v-card>
        </div>
        <div class="box-rank" v-if="sortedDataModal">
          <v-card elevation="0" class="wrapper">
            <div class="body bg-green">
              <div v-for="(data,inx) in sortedDataModal" :key="inx" class="box-rank-market">
                <div class="detail">
                  <div class="number">
                    {{ inx + 1 }}
                  </div>
                  <div>
                    <div class="sub-title">{{ $t('product.rank', {index: inx + 1}) }}</div>
                    <div class="name">{{ data.product.name }}</div>
                  </div>
                </div>
                <div class="progress">
                  <v-progress-linear :value="data.percent" color="green" height="4"></v-progress-linear>
                  <div class="txt-value">{{data.percent}}%</div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </v-card-text>
      <v-card-text v-if="!isLoading && typeChartDialog == 'rent_proportion' && dataModalPrepare">
        <div class="box-chart-type bd-bottom">
          <v-card elevation="0" class="wrapper">
            <div class="col-left">
              <div class="body">
                <div id="custom-pie-income-legend-dialog" class="product-category"></div>
              </div>
            </div>
            <div class="col-right">
              <div class="box-chart-rent container-chart-income-dialog position-relative">
                <canvas id="pie-chart-rent-dialog" v-show="dataModalPrepare && dataModalPrepare"></canvas>
                <div v-show="dataModalPrepare && !dataModalPrepare" class="no-data">
                  {{ $t('product.no_product') }}
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);

export default {
  props: {
    value: Boolean,
    marketId: String,
    marketName: String,
    projectId: String,
    dataModalPrepare: Object,
    typeChartDialog: {
      type: String,
      default: "product_type_proportion" // product_type_proportion or rent_proportion
    },
  },
  watch: {
    value(val) {
      if (val) this.initData()
    }
  },
  components: {
  },
  data() {
    return {
      isLoading:false,
      isMountedCheckPieChart: false,
      pieChartProductType : null,
      pieChartRentProportion : null,
    };
  },
  methods: {
    initData(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.$nextTick(() => {
        if(this.typeChartDialog == 'product_type_proportion'){
          this.initPieChartProductType(this.dataModalPrepare);
        }else{
          this.initPieChartRentProportion(this.dataModalPrepare);
        }
      });
      }, 100);
    },
    initPieChartProductType(dataRes) {
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: 20
          },
          plugins: {
            title: {
              display: false,
            },
            tooltip: {
              enabled: false,
              external : this.externalTooltipProductCategoryDialog,
            },
            legend: {
              display: false,
            },
            datalabels: {
              display:false,
              align: "top",
              anchor: "end",
              font: {
                size: 13,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: function (data, ctx) {
                return (
                  ctx.chart.data.labels[ctx.dataIndex] + " " + data.value + "%"
                );
              },
              offset : 20,
            }
          },
          responsive: true,
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-pie-legend-dialog');
              legendContainer.innerHTML = ''; 
              chart.data.datasets.forEach((dataset, datasetIndex) => {
                dataset.data.forEach((data, index) => {
                  const legendItem = document.createElement('div');
                  legendItem.classList.add('product-type-box');
                  const label = chart.data.labels[index];
                  const bgColor = dataset.backgroundColor[index];
                  legendItem.innerHTML = `
                    <div class="product-type-color" style="background-color:${bgColor};"></div>
                    <div class="product-type-text">${label}</div>
                  `;
                  
                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const sliceMeta = meta.data[index];
                    sliceMeta.hidden = !sliceMeta.hidden;

                    if (sliceMeta.hidden) {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'none';
                    }

                    chart.update(); 
                  });
                  const meta = chart.getDatasetMeta(datasetIndex);
                  const sliceMeta = meta.data[index];
                  if (sliceMeta.hidden) {
                    legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              });
            }
          }
        ]
      };

      if(dataRes){
        const colors = this.generateColors(Object.keys(dataRes.products).length);
        dataChart.data.datasets = [
          {
            label: "Product Category",
            data: [],
            backgroundColor: colors,
            borderWidth: 0,
            borderColor: ""
          }
        ];
        const sortedData = [];
        let sum = 0;
        for (const key in dataRes.products) {
          sum += dataRes.products[key].count;
        }
        for (const key in dataRes.products) {
          const data = dataRes.products[key];
          const percent = parseFloat((data.count / sum) * 100).toFixed(2);
          sortedData.push({
            label: data.product.name,
            value: percent,
            count : data.count,
            id: key,
            detail: data
          });
        }
        sortedData.sort((a, b) => b.value - a.value);
        dataChart.data.labels = sortedData.map(item => item.label);
        dataChart.data.datasets[0].data = sortedData.map((item,inx) => ({
            name : item.label,
            value: item.value,
            id: item.id,
            count : item.count,
            detail: item.detail,
            rank: inx + 1,
        }));
      }

      if (!this.pieChartProductType ) {
        let ctx = document.getElementById("pie-chart-dialog");
        if (ctx) this.pieChartProductType = new Chart(ctx, dataChart);
      } else {
        this.pieChartProductType.data = dataChart.data;
        this.pieChartProductType.update();
      }
    },
    initPieChartRentProportion(dataRes) {
      let _this = this;
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: 20
          },
          plugins: {
            title: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipPieIncomeDialog
            },
            datalabels: {
              display:false,
              align: "end",
              anchor: "end",
              font: {
                size: 13,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: function (data, ctx) {
                return (
                 `${ctx.chart.data.labels[ctx.dataIndex]}` + `\n ${this.$t('income.title')} : ${this.$helper.currencySign()}` +  `${parseFloat(data.value || 0)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                );
              },
              offset : 20,
            }
          },
          responsive: true,
          maintainAspectRatio: false,
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-pie-income-legend-dialog');
              legendContainer.innerHTML = ''; 
              chart.data.datasets.forEach((dataset, datasetIndex) => {
                dataset.data.forEach((data, index) => {
                  const legendItem = document.createElement('div');
                  legendItem.classList.add('product-type-box');
                  const label = chart.data.labels[index];
                  const bgColor = dataset.backgroundColor[index];
                  legendItem.innerHTML = `
                    <div class="product-type-color" style="background-color:${bgColor};"></div>
                    <div class="product-type-text">${label}</div>
                  `;
                  
                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const sliceMeta = meta.data[index];
                    sliceMeta.hidden = !sliceMeta.hidden;

                    if (sliceMeta.hidden) {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'none';
                    }

                    chart.update(); 
                  });
                  const meta = chart.getDatasetMeta(datasetIndex);
                  const sliceMeta = meta.data[index];
                  if (sliceMeta.hidden) {
                    legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              });
            }
          }
        ]
      };

      const colors = this.generateColors(Object.keys(dataRes.accountingProducts).length);
      dataChart.data.datasets = [
        {
          label: "Product Category",
          data: [],
          backgroundColor: colors,
          borderWidth: 0,
          borderColor: "#ddd"
        }
      ];

      let sum = 0;
      for (const key in dataRes.accountingProducts) {
        sum += dataRes.accountingProducts[key].totalValue;
      }

      for (const key in dataRes.accountingProducts) {
        const data = dataRes.accountingProducts[key];
        const percent = parseFloat((data.totalValue / sum) * 100).toFixed(2);
        if(data.totalValue > 0 ){
          dataChart.data.labels.push(data.accountingProduct.name);
          dataChart.data.datasets[0].data.push(
            {
              name:data.accountingProduct.name,
              value: data.totalValue, 
              id: key, 
              percent:percent,
              info: dataRes.accountingProducts[key]
            }
          );
        }
      }

      if (!this.pieChartRentProportion ) {
        let ctx = document.getElementById("pie-chart-rent-dialog");
        if (ctx) this.pieChartRentProportion = new Chart(ctx, dataChart);
      } else {
        this.pieChartRentProportion.data = dataChart.data;
        this.pieChartRentProportion.update();
      }
    },
    dismiss() {
      this.$emit("input", false);
      if(this.pieChartProductType){
        this.pieChartProductType.destroy();
        this.pieChartProductType = null;
      }
      if(this.pieChartRentProportion){
        this.pieChartRentProportion.destroy();
        this.pieChartRentProportion = null;
      }
    },
    externalTooltipPieIncomeDialog(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-pie-income-dialog');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-pie-income-dialog';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.container-chart-income-dialog');
        chartContainer.appendChild(tooltipEl);
      }
      const tooltipModel = context.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }
      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const color = tooltipModel.dataPoints[0].element.options.backgroundColor; 
        const bodyLines = [
          `
          <div style="font-size:14px !important"> 
            <div class="d-flex align-center">
              <div class="legend-color-dot" style="background-color:${color}"></div>
              <div>${data.name} (${data.percent}%)</div>  
            </div>
          </div>
          <div class="divider-solid"></div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('income.all_total_income')}
            </div>
            <div style="text-align: right;">
              ${this.$helper.toCurrency(parseFloat(data.value || 0), null, { isPrefixSign: true })}
            </div>
          </div>`,
        
        ];
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;
        
        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        const tooltipWidth = tooltipEl.offsetWidth; 
        const chartContainer = document.querySelector('.container-chart-income-dialog'); 
        const chartWidth = chartContainer.clientWidth; 
        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10; 
        }
        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    externalTooltipProductCategoryDialog(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-product-category-dialog');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-product-category-dialog';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        // document.body.appendChild(tooltipEl);
        const chartContainer = document.querySelector('.container-pie-tooltip');
        chartContainer.appendChild(tooltipEl);
      }
      const tooltipModel = context?.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }

      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const color = tooltipModel.dataPoints[0].element.options.backgroundColor; 
        const bodyLines = [
          `
          <div style="font-size:14px !important">
            <div class="d-flex align-center">
              <div class="legend-color-dot" style="background-color:${color}"></div>
              <div>${data.name} (${data.value}%)</div>  
            </div>
          </div>
          <div class="divider-solid"></div>
          <div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('income.top_income')}
            </div>
            <div style="text-align: right;">
              ${this.$t('product.rank', { index: data.rank })}
            </div>
          </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('area.sold_stall')}
            </div>
            <div style="text-align: right;">
              ${this.$helper.toArabic(data.detail.count)} ${this.$t('area.space')}
            </div>
          </div>`,
        
        ];
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;
        
        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        // Check if the tooltip is overlapping the right edge of the chart
        const tooltipWidth = tooltipEl.offsetWidth; // Get the tooltip's width
        const chartContainer = document.querySelector('.container-pie-tooltip'); // Your chart container
        const chartWidth = chartContainer.clientWidth; // Get the width of the chart container

        // Adjust position if overlapping
        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10; // 10px padding from the right edge
        }

        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    generateColors(count) {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const r = (Math.random() * 255).toFixed(2);
        const g = (Math.random() * 255).toFixed(2);
        const b = (Math.random() * 255).toFixed(2);
        colors.push(`rgb(${r}, ${g}, ${b})`);
      }
      return colors;
    }
  },
  computed : {
    sortedDataModal() {
      if (this.typeChartDialog === 'product_type_proportion') {
        const productsArray = Object.values(this.dataModalPrepare.products);
        const total = productsArray.reduce((sum, product) => sum + product.count, 0);
        return productsArray
          .map(product => ({
            ...product,
            percent: ((product.count / total) * 100).toFixed(2) 
          }))
          .sort((a, b) => b.count - a.count);
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.box-chart-type{
  overflow: hidden;
  box-shadow: 0px 3px 32px 4px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  border-radius: 10px;
  .wrapper{
    height: 450px;
    padding: 10px 15px;
    border-radius: 10px;
    display:flex;
  }
  .col-left{
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    width: 50%;
    display: flex;
    flex-direction: column;
    .header{
      .txt-title{
        font-size: 24px;
        font-weight: 700;
      }
      .sub-title{
        font-size: 20px;
        font-weight: 400;
        color: #777777;
      }
    }
    .body{
      flex: 1;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .product-category{
      display:grid;
      grid-template-columns: repeat(2,1fr);
      max-height: 300px;
      overflow-y: auto;
      .color{
        display:inline-block;
        width: 25px;
        height:25px;
        border-radius: 100%;
        background-color: #4CAF50;
      }
      .name{
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .col-right{
    padding: 10px;
    width: 50%;
    .no-data{
      font-size: 24px;
      text-align: center;
    }
  }
}

.pie-chart-box,
.box-chart-rent{
  width: 100%;
  height: 100%;
  & canvas{
    width: 100%;
    height: 100%;
  }
}

.bd-bottom{
  border-bottom: 10px solid #4AAA4E;
}

.position-relative{
  position: relative;
}

</style>

<style lang="scss">

.box-rank{
  .wrapper{
    border-radius: 10px;
    padding: 20px 0;
  }
  .header{
    display: flex;
    justify-content: space-between;
    .txt-title{
      font-size: 24px;
      font-weight: 700;
    }
    .sub-title{
      font-size: 20px;
      font-weight: 400;
      color: #777777;
    }
  }
  .body{
    &.bg-warning{
      .number{
        background: rgba(239, 194, 80, 0.3);
        color: #EFC250;
      }
    }
    &.bg-green{
      .number{
        background: rgba(76, 175, 80, 0.12);
        color: #4CAF50;
      }
    }
    .box-rank-market{
      border-radius: 10px;
      box-shadow: 0px 3px 32px 4px rgba(0, 0, 0, 0.1);
      display: flex;
      padding: 10px;
      justify-content: space-between;
      cursor: pointer;
      &.active{
        border: 1px solid #EFC250;
      }
      &:not(:last-child){
        margin-bottom: 10px;
      }
      .detail{
        display: flex;
        align-items: center;
        .number{
          font-size: 24px;
          border-radius: 100%;
          min-width: 52px;
          height: 52px;
          width: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          margin-right: 10px;
        }
        .sub-title{
          font-size: 14px;
          font-weight: 400;
          color: #777777;
        }
        .name{
          font-size: 24px;
        }
      }
      .progress{
        min-width: 250px;
        display: flex;
        align-items: center;
        gap: 10px;
        .percent{
          font-size: 20px;
        }
      }
    }
  }
}

.box-chart-type{
  .product-type {
    &-box{
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &-color{
      display: inline-block;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      align-items: center;
      margin-right: 10px;
    }
    &-text{
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
